import { NgModule } from "@angular/core";
import { TradableChartComponent } from "./tradable-chart.component";
import { ChartModule } from "../../../shared/chart/chart.module";
import { CoreModule } from "@modules/core/core.module";

const components = [TradableChartComponent];

@NgModule({
	imports: [CoreModule, ChartModule],
	declarations: [...components],
	exports: [...components]
})
export class TradableChartModule {}
